import { useState } from "react";
import axios from "axios";
import constate from "constate";

const [ItemStateProvider, useItemState] = constate(
  ({ item, request = null, defaultSelection = false }) => {
    const [isSelectingQuotes, setIsSelectingQuotes] = useState(
      defaultSelection
    );
    const [selectedQuote, setSelectedQuote] = useState(request?.last_quote);

    const startSelection = () => {
      setIsSelectingQuotes(true);
      setSelectedQuote(null);
    };

    const sendQuote = async () => {
      try {
        await axios.post(
          `/api/requests/${item.id}/send-quote/${selectedQuote.id}`
        );
        setIsSelectingQuotes(false);
      } catch (error) {
        console.error(error);
      }
    };

    return {
      isSelectingQuotes,
      startSelection,
      selectedQuote,
      setSelectedQuote,
      sendQuote,
    };
  }
);

export { ItemStateProvider, useItemState };
